import { render, staticRenderFns } from "./NaverPayReturnHold.vue?vue&type=template&id=3eff5da1&"
import script from "./NaverPayReturnHold.vue?vue&type=script&lang=ts&"
export * from "./NaverPayReturnHold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports